import { render } from "./PictureUpload.vue?vue&type=template&id=2ebbfea4&scoped=true"
import script from "./PictureUpload.vue?vue&type=script&lang=js"
export * from "./PictureUpload.vue?vue&type=script&lang=js"

import "./PictureUpload.vue?vue&type=style&index=0&id=2ebbfea4&scoped=true&lang=scss"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebbfea4"]])

export default __exports__